import NavAdmin from "../nav-admin/nav-admin";
import useUserStore from "../../utils/storeApp";

const HeaderAccount = () => {
  const { userRole } = useUserStore((state) => ({
    userRole: state.userRole,
  }));
  return (
    <header className="HeaderAccount" role="banner">
      {userRole === "SES ADMINISTRATOR" ||
      userRole === "ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR" ? (
          <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar" aria-label="Account settings header bar with admin navigation">
            <div className="container w-max2">
              {/*Main Header*/}
              <h5 className="sp-mx" id="account-header-title">
                <i className="bi bi-card-checklist" aria-hidden="true"></i>
                 <span className="spacer-margin2 v-set4" >Account Setting</span>
              </h5>
              {/*Admin Menus*/}
              <NavAdmin />
            </div>
          </nav>
      ) : null}
    </header>
  );
};

export default HeaderAccount;
